import { defineComponent as _defineComponent } from 'vue'
import { useMerchantInfo } from '@/store/merchant-info-module';
import { toRefs, onMounted } from 'vue';
import MerchantBg from './components/merchant-bg.vue';
import MerchantInfo from './components/merchant-info.vue';
import { setUpWeixinInit } from '@/utils/cache-setup-wx';
import { to } from '@tencent/wphk-base-utils';
import { MerchantType } from '@/types/merchant-info';
import QRPay from '@/components/qrpay.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { merchantConfig } = toRefs(useMerchantInfo());
// 更新页面标题
onMounted(async () => {
  if (merchantConfig.value.mrchName) {
    document.title = merchantConfig.value.mrchName;
  }

  // 隐藏复制链接按钮
  await to(setUpWeixinInit());
  if (merchantConfig.value.mrchType === MerchantType.mall) {
    wx.hideMenuItems({
      menuList: ['menuItem:copyUrl'],
    });
  }
});

return { __sfc: true,merchantConfig, MerchantBg, MerchantInfo, QRPay }
}

})